import React from 'react';

import ChartMetric from '../ChartMetric/ChartMetric';
import Loader from '../../../../../../../CommunityDashboard/components/CommunityDashboardPage/components/Loader/Loader';

import styles from './ProfileAttributesMetrics.module.css';

export default ({ profileAttributesData, profileAttributesFiltersLength }) => {
  if (!profileAttributesData && profileAttributesFiltersLength > 0) {
    return (
      <div className={styles.chartContainerBackground}>
        <div className={styles.loadingContainer}>
          <Loader fixed={false} />
        </div>
      </div>
    );
  }

  return profileAttributesData
    ? Object.entries(profileAttributesData).map(([title, chartData]) => (
        <ChartMetric
          title={title}
          chartData={chartData}
          metricWidth={
            chartData.values && chartData.values.length <= 5 ? 49 : 100
          }
          isSocioDemoChart={false}
        />
      ))
    : null;
};
